<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper" @click="$emit('closeModal')">
        <div class="row">
          <div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
          <div class="col-xs-12 col-sm-12 col-md-10 col-lg-8">
            <div class="modal-container" @click.stop>

                <div class="modal-header" style="justify-content: flex-end;">
                  <button type="button" class="close" @click="$emit('closeModal')">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>

                <div class="modal-body">
                  <h2 class="title" style="margin-bottom: 20px;">Peran Baru</h2>
                  <div class="row row-space">
                    <div class="col-xs-0 col-sm-3 col-md-3 col-lg-3"></div>
                    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                      <div class="input-group">
                        <label class="label">Nama Peran<span style="color: red;">*</span></label>
                        <input class="input--style-4" type="text" name="role" v-model="form.name" placeholder="Ketik Nama Peran">
                      </div>
                    </div>
                    <div class="col-xs-0 col-sm-3 col-md-3 col-lg-3"></div>
                  </div>
                  <div class="row">
                    <label class="label text-left">Izin<span style="color: red;">*</span></label>
                  </div>
                  <div class="row" v-if="moduleConfig != null">
                    <!-- Module Selection Starts -->
                    <div v-for="(module, index) in structure" class="innerBox w-100 mt-3" :class="(module.children != null) ? 'hoverable' : ''" @click="openBox(index)">
                      <div class="row">
                        <div class="custom-control custom-checkbox align-middle" :class="(mobile) ? 'col-8' : 'col-4'" style="padding-left:35px">
                          <input v-if="module.children == null" type="checkbox" class="custom-control-input" :id="module.title" :value="module.code" v-model="selected[index]">
                          <input v-else type="checkbox" class="custom-control-input" :id="module.title" v-indeterminate="moduleConfig[index].indeterminate" v-model="moduleConfig[index].checked" @change="selectAll(index)">

                          <label class="custom-control-label" :for="module.title">
                            <h4 style="margin: 0">{{ module.title }}</h4>
                          </label>
                        </div>
                        <div class="text-right" :class="(mobile) ? 'col-4' : 'col-8'">
                          <i v-if="module.children != null" class="fas fa-angle-right" :class="(moduleConfig[index].boxOpen) ? 'fa-rotate-90' : ''" style="font-size: 150%;"></i>
                        </div>
                      </div>
                      <hr v-if="module.children != null && moduleConfig[index].boxOpen">
                      <!-- Children Start -->
                      <div v-if="module.children != null && moduleConfig[index].boxOpen" class="row ml-3" @click.stop>
                        <div v-for="littleModule in module.children" class="col-12 mt-2 custom-control custom-checkbox align-middle" style="padding-left:35px">

                          <input
                            type="checkbox"
                            v-model="selected[index]"
                            class="custom-control-input"
                            :value="littleModule.code"
                            :id="littleModule.title"
                            @change="select(index)"
                          >
                          <label class="custom-control-label" :for="littleModule.title">{{ littleModule.title }}</label>
                        </div>
                      </div>
                      <!-- Children End -->
                    </div>
                    <!-- Module Selection Ends -->
                  </div>
                  <!-- Button Starts -->
                  <div class="row mt-5">
                    <div class="col text-center">
                      <button type="button" class="btn btn-outline-danger" style="width: 75px;" @click="$emit('closeModal')">Cancel</button>
                      <button type="button" class="btn btn-primary ml-4" style="width: 75px;" @click="submitForm()">Buat</button>
                    </div>
                  </div>
                  <!-- Button Ends -->
                </div>
            </div>
          </div>
        </div>
        <div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
      </div>
    </div>
  </transition>
</template>
  
  <script>
    import MultiSelect from 'vue-multiselect';
    import permissionList from './permissionList.json'
  
    export default {
      data () {
        return{
          mobile : this.isMobile(),
          form : {
            name : '',
          },
          postForm : {
            permission_id : [],
          },
          moduleConfig : null,
          selectModule : [],
          structure : [],
          selected : [],
        }
      },
      directives: {
        indeterminate: function(el, binding) {
          el.indeterminate = Boolean(binding.value)
        }
      },
      mounted () {
        this.generateStructure()
      },
      methods : {
        openBox(index){
          if(this.structure[index].children == null) return
          for(var i in this.moduleConfig){
            if(i == index)
              this.moduleConfig[index].boxOpen = !this.moduleConfig[index].boxOpen
            else
              this.moduleConfig[i].boxOpen = false
          }
        },
        selectAll(item){
          this.selected[item] = []
          if(this.moduleConfig[item].checked){
            this.selected[item] = this.selected[item].concat(this.structure[item].children.map(x => x.code))
          }
          this.moduleConfig[item].indeterminate = false;
        },
        select(item){
          this.moduleConfig[item].checked = false;
          if(this.selected[item].length == 0){
            this.moduleConfig[item].indeterminate = false;
          } else if (this.selected[item].length == this.structure[item].children.length){
            this.moduleConfig[item].indeterminate = false;
            this.moduleConfig[item].checked = true;
          } else {
            this.moduleConfig[item].indeterminate = true;
          }
        },
        concatPermission(){
          this.postForm.permission_id.length = 0;
          for(var i = 0; i < this.selected.length; i++){
            this.postForm.permission_id = this.postForm.permission_id.concat(this.selected[i]);
          }
          // console.log(JSON.stringify(this.postForm.permission_id));
        },
        generateStructure(){
          this.structure = JSON.parse(JSON.stringify(this.$store.state.modules));
          this.generateModuleConfig()
        },
        async generateModuleConfig(){
          var moduleConfig = []
          for(var i = 0; i < this.structure.length; i++){
            this.selected[i] = []
            moduleConfig.push({
              boxOpen : false,
              checked : false,
              indeterminate : false
            })
          }
          this.moduleConfig = moduleConfig
        },
        async submitForm () {
          let user_id;

          await this.concatPermission()

          if (this.form.name == '' || this.form.name == null) {
            this.$store.dispatch('triggerAlert', [false, ['Nama harus terisi']])
          } else if (this.postForm.permission_id == null || this.postForm.permission_id.length == 0) {
            this.$store.dispatch('triggerAlert', [false, ['Izin harus terisi minimal 1 buah']])
          } else {
            // this.form = this.form.filter(x => x != null)
            this.$http.post('/api/v1/roles', this.form)
            .then((resp)=>{
              this.setPermissions(resp.data.data.id)
            })
            .catch((err)=>{
              this.$store.dispatch('triggerAlert', [false, [err.response.data.data]])
              this.errorPrint(err.response.data.data)
            })
          }
        },
        setPermissions (role_id) {
          this.$http.put(`/api/v1/roles/${role_id}/permissions`, this.postForm)
          .then((resp)=>{
            this.$store.dispatch('triggerAlert', [true, [`Role ${this.form.name} telah berhasil dibuat`]])
            this.$emit('updateTable');
            this.$emit('closeModal');
          })
          .catch((err)=>{console.log(err)})
        }
      }
    }
  </script>
  
  <style scoped>  
  /* ==========================================================================
  #FORM made by Colorlib (https://colorlib.com)
  ========================================================================== */
  input {
    outline: none;
    margin: 0;
    border: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
    width: 100%;
    font-size: 14px;
    font-family: inherit;
  }
  
  .input--style-4 {
    line-height: 50px;
    background: #fafafa;
    -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    padding: 0 20px;
    font-size: 16px;
    color: #666;
    -webkit-transition: all 0.4s ease;
    -o-transition: all 0.4s ease;
    -moz-transition: all 0.4s ease;
    transition: all 0.4s ease;
  }
  
  .input--style-4::-webkit-input-placeholder {
    /* WebKit, Blink, Edge */
    color: #666;
  }
  
  .input--style-4:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #666;
    opacity: 1;
  }
  
  .input--style-4::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #666;
    opacity: 1;
  }
  
  .input--style-4:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #666;
  }
  
  .input--style-4:-ms-input-placeholder {
    /* Microsoft Edge */
    color: #666;
  }
  
  .label {
    font-size: 16px;
    color: #555;
    text-transform: capitalize;
    display: block;
    margin-bottom: 5px;
  }
  
  .radio-container {
    display: inline-block;
    position: relative;
    padding-left: 30px;
    cursor: pointer;
    font-size: 16px;
    color: #666;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  
  .radio-container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
  }
  
  .radio-container input:checked ~ .checkmark {
    background-color: #e5e5e5;
  }
  
  .radio-container input:checked ~ .checkmark:after {
    display: block;
  }
  
  .radio-container .checkmark:after {
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    -o-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 12px;
    height: 12px;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
    background: #57b846;
  }
  
  .checkmark {
    position: absolute;
    top: 50%;
    -webkit-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    -o-transform: translateY(-50%);
    transform: translateY(-50%);
    left: 0;
    height: 20px;
    width: 20px;
    background-color: #e5e5e5;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
    -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  }
  
  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }
  
  .input-group {
    position: relative;
    /* margin-bottom: 22px; */
    padding:20px;
  }
  
  .input-group-icon {
    position: relative;
  }
  
  .input-icon {
    position: absolute;
    font-size: 18px;
    color: #999;
    right: 18px;
    top: 50%;
    -webkit-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    -o-transform: translateY(-50%);
    transform: translateY(-50%);
    cursor: pointer;
  }
  
  /* ==========================================================================
     #TITLE made by Colorlib (https://colorlib.com)
     ========================================================================== */
  .title {
    font-size: 40px;
    color: #525252;
    margin-bottom: 40px;
    text-align: center;
  }

  .hoverable:hover{
    cursor: pointer;
  }
  </style>
  